import type {
  GroupAnalyzeResponseData,
  AngleEnum,
  BulkCreateProductSKUPayload,
} from "@/types/product-sku.types";
import { SmartUploadFormValues } from "@/schema/smartupload.schema";

export function mapAnalysisToFormValues(
  result: GroupAnalyzeResponseData,
): SmartUploadFormValues {
  return {
    products: result.categories.flatMap((cat) =>
      cat.products.map((p) => ({
        id: p.id,
        name: p.name,
        sku_code: p.sku_code ?? "",
        category: p.category ?? cat.name ?? "",
        confidence: p.confidence,
        variants: p.variants.map((v) => ({
          id: v.id,
          name: v.name,
          images: v.products.map((img) => ({
            id: img.id,
            product_url: img.product_url,
            angle: img.angle,
          })),
        })),
        collapsed: false,
      })),
    ),
  };
}

export function buildBulkPayload(
  values: SmartUploadFormValues,
): BulkCreateProductSKUPayload {
  return {
    items: values.products.map((p) => ({
      name: p.name,
      sku_code: p.sku_code || null,
      category: p.category || null,
      variants: p.variants.map((v) => ({
        name: v.name,
        products: v.images.map((img) => ({
          url: img.product_url,
          angle: (img.angle as AngleEnum) || null,
        })),
      })),
    })),
  };
}
